import React, { useState } from "react";
import { Box, Collapse, IconButton } from "@mui/material";
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from "@mui/icons-material";

interface ExpandableDetailsProps {
  children?: React.ReactNode; // Optional: immer sichtbarer Inhalt oberhalb des Pfeils
  details: React.ReactNode; // Inhalt, der erst beim Aufklappen erscheint
  defaultExpanded?: boolean;
}

/**
 * Zeigt children (falls vorhanden) immer an, danach details eingeklappt.
 * Der Toggle-Pfeil steht immer ganz am Ende - bei aufgeklapptem details also
 * unter dem Detail-Inhalt - und ragt per negativem margin-bottom in das
 * untere Innenpadding der umgebenden Section hinein, sodass er im Randbereich
 * der Kachel sitzt statt zusätzlichen Platz im Inhalt zu beanspruchen.
 */
const ExpandableDetails: React.FC<ExpandableDetailsProps> = ({
  children,
  details,
  defaultExpanded = false,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Box>
      {children}
      <Collapse in={expanded} timeout="auto" unmountOnExit={false}>
        {details}
      </Collapse>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: 1,
          mb: -2,
        }}
      >
        <IconButton
          size="small"
          onClick={() => setExpanded((prev) => !prev)}
          sx={{
            color: expanded ? "primary.main" : "text.secondary",
            opacity: 0.5,
            p: 0.5,
          }}
        >
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>
    </Box>
  );
};

export default ExpandableDetails;
